export const GET_SHIPPINGS_LIST_IN_PROGRESS = "GET_SHIPPINGS_LIST_IN_PROGRESS";
export const GET_SHIPPINGS_LIST_SUCCESS = "GET_SHIPPINGS_LIST_SUCCESS";
export const GET_SHIPPINGS_LIST_FAIL = "GET_SHIPPINGS_LIST_FAIL";

export const GET_SHIPPINGS_FILTERS_IN_PROGRESS =
  "GET_SHIPPINGS_FILTERS_IN_PROGRESS";
export const GET_SHIPPINGS_FILTERS_SUCCESS = "GET_SHIPPINGS_FILTERS_SUCCESS";
export const GET_SHIPPINGS_FILTERS_FAIL = "GET_SHIPPINGS_FILTERS_FAIL";

export const GET_SHIPPINGS_COUNT_IN_PROGRESS =
  "GET_SHIPPINGS_COUNT_IN_PROGRESS";
export const GET_SHIPPINGS_COUNT_SUCCESS = "GET_SHIPPINGS_COUNT_SUCCESS";
export const GET_SHIPPINGS_COUNT_FAIL = "GET_SHIPPINGS_COUNT_FAIL";
